import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ViewUpdateService } from '@scaffold/services/view-update.service';
import { SearchModalComponent } from '@scaffold/editor/controls/search-modal/search-modal.component';
import { ActivatedRoute } from '@angular/router';
import { RenderedService } from '@scaffold/view/rendered/rendered.service';
import { CourseService } from '@scaffold/services/course.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import {
  ScaffoldDialogService,
  ScaffoldDialogRef,
} from '@app/framework/dialog/scaffold-dialog.service';
import { searchObject } from '@app/framework/search-bar/search-bar.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslationService } from '@services/translation.service';

/**
 * @fileoverview this component allows linking data items of a certain type
 */

@Component({
    selector: 'scaffold-data-link',
    templateUrl: './data-link.component.html',
    styleUrls: ['../../rendered.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DataLinkComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  loading = false;
  isProcessing = false;
  public destroy$: Subject<boolean> = new Subject<boolean>();
  dialogRef: ScaffoldDialogRef;
  listTotalNumberOfItems = 0;
  searchData;
  link_data = [];
  _perPage = 25;
  set perPage(count) {
    console.log(count);
    this._perPage = count;
    this.update();
  }
  get perPage() {
    return this._perPage;
  }
  itemCount = 0;
  private _active = 1;
  set active(page: number) {
    console.log(page);
    this._active = page;
    this.getListItems();
    this.redraw();
  }
  get active(): number {
    return this._active;
  }
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private viewUpdate: ViewUpdateService,
    public dialog: ScaffoldDialogService,
    private route: ActivatedRoute,
    private courseService: CourseService,
    private translationService: TranslationService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.cdr.detectChanges();
      });
    if (this.item.linked) {
      this.item.linked.forEach(() => this.link_data.push({}));
    }
    if (this.item.pageCounts && this.item.pageCounts[0]) {
      this._perPage = this.item.pageCounts[0].count;
    }

    this.listTotalNumberOfItems = this?.item?.linked?.length || 0;
    if (this?.item?.linked) {
      this.listTotalNumberOfItems = this?.item?.linked?.length;
      this?.item?.linked.forEach(item => this?.link_data?.push({}));
    }
    this.listTotalNumberOfItems = this?.item?.totalItems || 0;
    this.itemCount = this?.item?.totalItems || 0;
    this.viewUpdate
      .registerListUpdate()
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        if (data && this.item.toload_type === data.type) {
          if (data.hasOwnProperty('removed')) {
            let index = -1;
            if (
              (data.list_type === 'link' && this.info.id === data.parent_id) ||
              data.list_type === 'list'
            ) {
              this.isProcessing = true;
              this.item.linked.forEach((item, i) => {
                if (item.id == data.removed) {
                  index = i;
                }
              });
              if (index >= 0) {
                this.item.linked.splice(index, 1);
                this.listTotalNumberOfItems = Math.max(
                  0,
                  this.listTotalNumberOfItems - 1
                );
                this.itemCount = Math.max(0, this.itemCount - 1);
              }
              index = -1;
              this.info.links.forEach((item, i) => {
                if (item.linked_id == data.removed) {
                  index = i;
                }
              });
              if (index >= 0) {
                this.info.links.splice(index, 1);
              }
              this.isProcessing = false;
            }
            this.cdr.detectChanges();
          }
          if (data.hasOwnProperty('added')) {
            if (data.list_type === 'link' && this.info.id == data.parent_id) {
              this.isProcessing = true;
              this.cdr.detectChanges();
              this.courseService
                .get(
                  data.added.type +
                    '/' +
                    data.added.id +
                    '?mode=' +
                    (this.item.toload_mode || 'list')
                )
                .subscribe(co => {
                  if (co.push) {
                    co = co[0];
                  }

                  if (co.listItems) {
                    co = co.listItems[0];
                  }
                  co.link_id = data.added.link_id;
                  co.link_parent = this.info.id;
                  co.link_parent_type = this.info.type;
                  this.item.linked.push(co);
                  this.item.linked.sort((a, b) => {
                    let order = Number(a.position) - Number(b.position);
                    if (order === 0) {
                      if (a.id === b.parent_id) {
                        order = -1;
                      }
                      if (b.id === a.parent_id) {
                        order = 1;
                      }
                    }
                    return order;
                  });
                  this.info.links.push({
                    linked_id: co.id,
                    type: co.type,
                    title: co.title,
                  });
                  this.listTotalNumberOfItems++;
                  this.itemCount++;
                  this.isProcessing = false;
                  this.cdr.detectChanges();
                  setTimeout(() => {
                    this.cdr.detectChanges();
                  }, 500);
                });
            }
          }
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  getContext() {
    console.log('CONTEXT: ' + this.item.parent_context);
    let context;
    if (this.item.parent_context === 'specified') {
      if (this.item.specified_type && this.item.value) {
        context = { type: this.item.specified_type, id: this.item.value };
      } else {
        context = null;
      }
    } else if (this.item.parent_context === 'all') {
      context = null;
    } else {
      context = {
        type: 'courses',
        id: this.courseService.id,
        get_all: this.item.get_all,
      };
      if (this.item.get_all) {
        context.get_all = true;
      }
    }
    return context;
  }

  openSearch(selectedItem, context, allow_multiple?): void {
    let translatedLabel;
    if (this.item.translation_key_window_label) {
      translatedLabel = this.translationService.getTranslatedContent(
        this.item.translation_key_window_label
      );
      translatedLabel = !this.item.text_transform
        ? translatedLabel
        : this.translationService.transform(
            translatedLabel,
            this.item.translation_key
          );
    }
    console.log(context);
    console.log(this.item);
    const settings: any = {
      context: {
        data: {
          paginate_results: true,
          selectedItem: selectedItem,
          currentValue: this.item.value,
          type: this.item.type,
          search_type: this.item.toload_type,
          search_mode: this.item.search_mode || 'list',
          context: context,
          route: this.route,
          allow_multiple: allow_multiple,
          window_title: translatedLabel
            ? translatedLabel
            : this.item.search_title && this.item.search_title.length > 0
              ? this.item.search_title
              : 'Select Items to Link' +
                (selectedItem.title ? ' to ' + selectedItem.title : ''),
          horizontal_list: this.item.horizontal_list,
          hide_search: this.item.hide_search,
          filter: this.item.filter_search,
          params: { param: this.item.param, req_value: this.item.req_value },
          prevent_create: this.item.prevent_create,
          use_dynamic_headers: this.item.use_dynamic_headers,
          headers: this.item?.headers,
        },
      },
    };
    this.dialogRef = this.dialog.open(SearchModalComponent, settings);

    this.dialogRef.onClose.subscribe(result => {
      if (result && result.length > 0) {
        this.renderedService.createLink(
          this.item,
          selectedItem,
          result,
          this.item.set_position
        );
      }
    });
  }
  /**
   *Get a filtered list of item in this list based on any search settting
   * */
  getListItems() {
    this.loading = true;
    let query = '';
    if (this.item.paginate_results) {
      query += '&pageNumber=' + (this.active - 1);

      if (this.perPage) {
        query += '&perPage=' + this.perPage;
      }
    }
    if (this.searchData && this.searchData.key != null) {
      query +=
        '&searchParam=' +
        this.searchData.key +
        '&searchTerm=' +
        encodeURIComponent(this.searchData.term);
    }
    query += '&data_items=linked';
    const url = this.generateListUrl();
    this.courseService.get(url + query).subscribe(co => {
      this.processItems(co);
    });
  }
  search(data: searchObject) {
    this.searchData = data;
    this._active = 1;
    this.getListItems();
  }

  perPageChange(e) {
    this.perPage = e;
    this.active = 1;
  }
  /**
   * Generates url to load item for this list
   * */
  generateListUrl(): string {
    const base = this.item.toload_type;
    let url = '';

    if (this.info) {
      if (this.info.type && this.info.id) {
        url = this.info.type + '/' + this.info.id + '/' + base;
      } else {
        url = '' + base;
      }
    }
    url += `?mode=${this.item.toload_mode || 'list'}`;
    return url;
  }

  processItems(co, initial?) {
    if (!this.item.linked) {
      this.item.linked = [];
    }
    if (co && co.totalItems) {
      this.listTotalNumberOfItems = co.totalItems;
    }
    if (co && co.push) {
      co = { listItems: co };
      this.listTotalNumberOfItems = co.id;
    }
    if (co && co.id) {
      co = { listItems: [co] };
      this.listTotalNumberOfItems = 1;
    }
    if (!this.listTotalNumberOfItems) {
      this.listTotalNumberOfItems = co?.listItems?.length || 0;
    }
    console.log(JSON.stringify(this.item.linked.map(i => i.title)));

    this.item.linked = co.listItems;

    this.itemCount =
      co?.totalItems ||
      co?.listItems?.length ||
      this.listTotalNumberOfItems ||
      0;
    this.loading = false;
    this.update();
  }
  getCountLabel() {
    if (!this.listTotalNumberOfItems) return '';
    let label = '';
    const of = this.translationService.getTranslatedContent('of');
    const items = this.translationService.getTranslatedContent(
      'items',
      'Items'
    );
    if (this.item.paginate_results) {
      const start = this.active * this.perPage - this.perPage + 1;
      const end = Math.min(
        this.active * this.perPage,
        this.listTotalNumberOfItems
      );
      label = `${start} - ${end} ${of} ${this.listTotalNumberOfItems} ${items}`;
    } else {
      if (this.listTotalNumberOfItems && this.listTotalNumberOfItems > 0) {
        label = `${this.listTotalNumberOfItems} ${items}`;
      }
    }
    return label;
  }
}
